import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-PlusShape",
  "use": "svg-icon-PlusShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg-icon-PlusShape\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M8.875 14.127a.875.875 0 0 1-1.75 0V8.875H1.877a.875.875 0 0 1 0-1.75h5.248V1.884a.875.875 0 1 1 1.75 0v5.241h5.249a.875.875 0 0 1 0 1.75H8.875v5.252z\" fill=\"#000\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol